import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateDraftEmployeeBasicsStepInput,
  PayrollCreateDraftEmployeeGraphQLRequest,
  PayrollCreateDraftEmployeeResponse,
} from '../types';

const payrollCreateDraftEmployeeMutation = gql`
  mutation PayrollCreateDraftEmployee($input: PayrollUpdateDraftEmployeeBasicsStepInput!) {
    payrollCreateDraftEmployee(input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const createDraftEmployee = (input: PayrollUpdateDraftEmployeeBasicsStepInput) => {
  return graphQLApi<PayrollCreateDraftEmployeeResponse, PayrollCreateDraftEmployeeGraphQLRequest>({
    query: payrollCreateDraftEmployeeMutation,
    queryVariables: { input },
  });
};
